import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  CustomerLoginReducer,
  SendOTPReducer,
  GetLoggedInCustomerReducer,
  ChangePasswordReducer,
  CreateCustomerUserReducer,
  GetCustomerUsersReducer,
  GetCustomerUserByIdReducer,
  UpdateCustomerUserReducer,
  DeleteCustomerUserReducer,
  GetCustomerUserPermissionsReducer,
  GetLoggedInCustomerLoginsReducer,
  UpdateCustomerProfileReducer,
  GetAllCountryReducer,
  ChangePasswordFromProfileReducer,
  GetManageBookingDataReducer,
  CheckLoggedInUserPCCReducer,
  PrintItineraryDataReducer,
  EmailItineraryDataReducer,
  CheckCustomerUserUsernameAvailabilityReducer,
  GetLoggedInCustomerUserReducer,
  UpdateCustomerUserProfileReducer,
  GetCustomerUserLogosReducer,
  DeleteCustomerUserLogoReducer,
  GetTicketReportDataReducer,
  GetTpBatchReportDataReducer,
  GetCurrencyReducer,
  DownloadExcelFileReducer,
  DownloadCSVFileReducer,
  InvoiceDisplayReducer,
  EmailMultiPccTicketReportReducer,
  GetCustomerByIdReducer,
  GetCustomerLoginsByIdReducer,
  UpdateCustomerUserDefaultLogoReducer,
  GetChildCustomerByParentIdReducer,
  GetCustomersReducer,
  GetCustomerUserLogsReducer,
  GetCustomerStaticDataByCustIDReducer,
  GetCustomerLogosReducer,
  DeleteCustomerLogoReducer,
  UpdateCustomerDefaultLogoReducer,
} from "../reducers/CustomerReducer";

const rootReducer = combineReducers({
  CustomerLogin: CustomerLoginReducer,
  SendOTPData: SendOTPReducer,
  GetLoggedInCustomer: GetLoggedInCustomerReducer,
  ChangePassword: ChangePasswordReducer,
  CreateCustomerUser: CreateCustomerUserReducer,
  GetCustomerUsers: GetCustomerUsersReducer,
  GetCustomerUserById: GetCustomerUserByIdReducer,
  UpdateCustomerUser: UpdateCustomerUserReducer,
  DeleteCustomerUser: DeleteCustomerUserReducer,
  GetCustomerUserPermissions: GetCustomerUserPermissionsReducer,
  GetLoggedInCustomerLogins: GetLoggedInCustomerLoginsReducer,
  UpdateCustomerProfile: UpdateCustomerProfileReducer,
  GetAllCountry: GetAllCountryReducer,
  ChangePasswordFromProfile: ChangePasswordFromProfileReducer,
  GetManageBookingData: GetManageBookingDataReducer,
  CheckLoggedInUserPCC: CheckLoggedInUserPCCReducer,
  PrintItineraryData: PrintItineraryDataReducer,
  EmailItineraryData: EmailItineraryDataReducer,
  CheckCustomerUserUsernameAvailability:
    CheckCustomerUserUsernameAvailabilityReducer,
  GetLoggedInCustomerUser: GetLoggedInCustomerUserReducer,
  UpdateCustomerUserProfile: UpdateCustomerUserProfileReducer,
  GetCustomerUserLogos: GetCustomerUserLogosReducer,
  DeleteCustomerUserLogo: DeleteCustomerUserLogoReducer,
  GetTicketReportData: GetTicketReportDataReducer,
  GetTpBatchReportData: GetTpBatchReportDataReducer,
  GetCurrency: GetCurrencyReducer,
  DownloadExcelFile: DownloadExcelFileReducer,
  DownloadCSVFile: DownloadCSVFileReducer,
  InvoiceDisplay: InvoiceDisplayReducer,
  EmailMultiPccTicketReport: EmailMultiPccTicketReportReducer,
  GetCustomerById: GetCustomerByIdReducer,
  GetCustomerLoginsById: GetCustomerLoginsByIdReducer,
  UpdateCustomerUserDefaultLogo: UpdateCustomerUserDefaultLogoReducer,
  GetChildCustomerByParentId: GetChildCustomerByParentIdReducer,
  GetCustomers: GetCustomersReducer,
  GetCustomerUserLogs: GetCustomerUserLogsReducer,
  GetCustomerStaticDataByCustID: GetCustomerStaticDataByCustIDReducer,
  GetCustomerLogos: GetCustomerLogosReducer,
  DeleteCustomerLogo: DeleteCustomerLogoReducer,
  UpdateCustomerDefaultLogo: UpdateCustomerDefaultLogoReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
